module.exports = __webpack_public_path__ + "img/oufu_151x171_5x11.prt.b162f894.jpg";